// Построява хронологията на една сметка от вече записаните одит редове.
// Реконструира салдото след всяка операция (от `total_amount` в отговора) и
// маркира съмнителни поведенчески шарки — всичко чисто клиентско, без база.

import type { TFunction } from "i18next";
import type { AuditLogEntry, AuditLogDetail } from "../../../../api/auditLogs";
import {
  classifyAction,
  kindTone,
  statusInfo,
  billBalanceAfter,
  type Tone,
} from "./interpret";

export interface TimelineStep {
  id: number;
  operation: string;
  timestamp: string;
  kind: string;
  tone: Tone;
  ok: boolean;
  reason?: string;
  balance: number | null;
  /** Маркер за съмнителна шарка (преведен текст), ако има. */
  flag?: string;
}

export function buildTimeline(
  items: AuditLogEntry[],
  detailById: Map<number, AuditLogDetail | undefined>,
  t: TFunction,
): TimelineStep[] {
  const steps: TimelineStep[] = items.map((it) => {
    const kind = classifyAction(it.method, it.path);
    const detail = detailById.get(it.id);
    const httpOk = it.status_code >= 200 && it.status_code < 300;
    const si = detail ? statusInfo(detail) : { ok: httpOk, reason: undefined };
    return {
      id: it.id,
      operation: it.operation,
      timestamp: it.timestamp,
      kind,
      tone: kindTone(kind),
      ok: si.ok,
      reason: si.reason,
      balance: detail ? billBalanceAfter(detail) : null,
    };
  });

  // ── Поведенчески флагове (върху подредената по време последователност) ──
  let discountActive = false;
  let closedOk = false;
  for (const s of steps) {
    if (
      s.kind === "applyDiscount" ||
      s.kind === "applyItemDiscount" ||
      s.kind === "applyItemDiscounts"
    ) {
      discountActive = true;
    } else if (s.kind === "removeDiscount") {
      if (discountActive) s.flag = t("auditLogDetail.human.flagDiscountReverted");
      discountActive = false;
    }
    if (s.kind === "close" && s.ok) {
      closedOk = true;
    } else if (
      closedOk &&
      (s.kind === "cancelItem" ||
        s.kind === "cancelItems" ||
        s.kind === "cancelAll")
    ) {
      s.flag = t("auditLogDetail.human.flagCancelAfterClose");
    }
    if (!s.ok && !s.flag) s.flag = t("auditLogDetail.human.flagFailed");
  }

  return steps;
}
